import moment from 'moment';
import _ from 'lodash';

export default {

    currentSearchTerm: (state, getters) => {
        return state.searchTerm;
    },
    currentSite: (state, getters) => {
        return state.selectedSite;
    },
    siteRelatedMotors: (state, getters) => {
        if (getters.currentSite){
            return getters.motor.filter(m => m.site_uid === getters.currentSite.uid)
        }
        return [];
    },
    darkMode() {
        return false;
    },
    defaultLanguage() {
        return 'fr';
    },
    displayAppSearchBar() {
        return false;
    },

    displayAuthFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.userIsAuthenticated;
    },
    displayChooseEntityFullOverlay(){
        // DO NOT DISPLAY view Choose Entity
        return false;
    },

    displayLoadingFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.modelsUnscopedLoaded;
    },
    enableGroupsAdministration(){
        return true;
    },
    enableUsersAdministration(){
        return true;
    },
    enablePermissionAdministration(){
        return true;
    },
    enableGroupsSideBarMenu(){
        return true;
    },
    enableUsersSideBarMenu(){
        return true;
    },
    enableDownloadCsvGroups(){
        return false;
    },
    enableDownloadCsvUsers(){
        return false;
    },
    enableRegister(){
        return false;
    },
    enableResetPassword(){
        return false;
    },
    enableSidebarCollapse(){
        return false;
    },
    enableLoginByEmail(){
        return false;
    },
    enableCreateUser(){
        return false;
    },
    enableCreateGroup(){
        return false;
    },
    enableDeleteGroup() {
        return true;
    },
    enableManageNotifications() {
        return false;
    },
    enableManageOtherUsersNotifications() {
        return false;
    },

    // Pictures
    loginImage() {
        return '/static/images/login-image2.jpg';
    },
    // backgroundFile1() {
    //     return '/static/img/backgroundFile1.jpg';
    // },
    // backgroundFile2() {
    //     return '/static/img/backgroundFile2.jpg';
    // },
    logoFile() {
        return '/static/images/logo_file.png';
    },
    // logoFileTopHeader() {
    //     return '/static/img/logoFileTopHeader.png';
    // },
    // logoFileBackgroundColor(/*state, getters, rootState*/) {
    //     return 'transparent';
    // },
    // logoFileTopHeader(/*state, getters*/) {
    //     // return getters.currentEntity.logo_file_topHeader;
    //     return ImageBase64.logoFileTopHeader;
    // },
    // logoFileTopHeaderBackgroundColor(/*state, getters*/) {
    //     return '#333';
    // },
    getScore(){
        let availableProps = {
            'detail_regulation_uid': 'motorRegulationDetailByUid',
            'age_uid': 'motorAgeByUid',
            'application_uid': 'motorApplicationByUid',
            'need_uid': 'motorNeedByUid',
            'technology_uid': 'motorTechnologyByUid',
            'usage_uid': 'motorUsageByUid',
        }
        let total = 1;
        return (view) => {
            let motorData = view.form;
            // get score for voltage
            // The rule is
            //    - if 380 < V < 400 : weight = 1
            //    - else : weight = 0
            if (motorData.detail_un < 380 || motorData.detail_un > 400){
                return 0
            }
            // get score for speed
            // The rule is
            //    - if 1400 < s < 1500 or 2900 < s < 2999 : weight = 1
            //    - else : weight = 0
            if (
                !_.inRange(motorData.detail_speed, 1400, 1500) &&
                !_.inRange(motorData.detail_speed, 2900, 2999)
            ){
                return 0
            }
            // get score for power
            // The rule is
            //    -  3 <= Pn <= 10kW: 3
            //    -  10 < Pn <= 50kW: 5
            //    -  50 < Pn <= 100kW: 7
            //    -  100 < Pn <= 500kW: 10
            //    -  Pn < 3kW or Pn > 500kW: 0
            if(motorData.detail_pn < 3){
                return 0
            }else if(motorData.detail_pn <= 10){
                total = 3
            }else if(motorData.detail_pn <= 50){
                total = 5
            }else if(motorData.detail_pn <= 100){
                total = 7
            }else if(motorData.detail_pn <= 500){
                total = 10
            }else{
                return 0
            }
            // Get score for availableProps
            for (const [key, value] of Object.entries(motorData)){
                if (!Object.keys(availableProps).includes(key)){
                    continue
                }
                let getterMethodName = availableProps[key];
                if (view[getterMethodName]) {
                    const foreignObject = view[getterMethodName](value);
                    if (foreignObject && foreignObject.weight !== undefined) total = total * foreignObject.weight;
                }
            }
            return total
        }
    },
    getFormattedAuditDate(){
        return (audit) => {
            let date = audit.date;
            return date ? moment(String(date)).format("MM/DD/YYYY à HH:mm:ss") : '(date non fournie)'
        }
    },
    auditSelectedMotorsUids(state, getters){
        return (audit) => {
            let auditData = audit.data
            if (!Object.values(auditData)[0]){
                return []
            }
            return JSON.parse(Object.values(auditData)[0])
        }
    },
    IsUserAllowedToLogin(state, getters){
        return (user) => {
            // Check if user is at least manager
            return ["superuser", "admin", "manager"].includes(user.level)
        }
    },
    isApiValoUsed(state){
        return state.apiValoAuth;

    }
};



// WEBPACK FOOTER //
// ./src/store/getters.js